import { render, staticRenderFns } from "./faq.page.vue?vue&type=template&id=a8185dea&scoped=true&"
import script from "./faq.page.vue?vue&type=script&lang=js&"
export * from "./faq.page.vue?vue&type=script&lang=js&"
import style0 from "./faq.page.vue?vue&type=style&index=0&id=a8185dea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8185dea",
  null
  
)

export default component.exports